import { FC } from 'react';
import { RenderFilters } from '../../../Components/Custom/RenderFilters';
import { RenderSorting } from '../../../Components/Custom/RenderSorting';
import countries from '../../../common/countries';
import {
  INPUT_TYPE_DATE_RANGE,
  INPUT_TYPE_SEARCH,
  INPUT_TYPE_SELECT
} from '../../../helpers/helpers';

interface FiltersProps {
  params: URLSearchParams;
  setParams: any;
  initialParams?: any;
}

export const Filters: FC<FiltersProps> = ({
  params,
  initialParams,
  setParams
}) => {
  const kycVerificationStatusOptions = [
    { label: 'Not Started', value: 'NOT_STARTED' },
    { label: 'Pending', value: 'PENDING' },
    { label: 'Verified', value: 'VERIFIED' },
    { label: 'Rejected', value: 'REJECTED' }
  ];

  const structureSideOptions = [
    { label: 'Test', value: '0' },
    { label: 'Prod', value: '1' }
  ];

  const packageRankTypeOptions = [
    { label: 'Qualified partner', value: '18' },
    { label: 'Star', value: '19' },
    { label: 'Builder', value: '1' },
    { label: 'Elite Builder', value: '2' },
    { label: 'Champion', value: '3' },
    { label: 'Bronze', value: '4' },
    { label: 'Silver', value: '5' },
    { label: 'Gold', value: '6' },
    { label: 'Diamond', value: '7' },
    { label: 'Blue Diamond', value: '8' },
    { label: 'Black Diamond', value: '9' },
    { label: 'Crown Diamond', value: '10' },
    { label: 'Ambassador', value: '11' },
    { label: 'Royal Ambassador', value: '12' },
    { label: 'Grand Ambassador', value: '13' },
    { label: 'Legend', value: '14' }
    // { label: 'G.O.A.T', value: '15' },
    // { label: 'Legendary G.O.A.T', value: '20' },
    // { label: 'Billionaire', value: '21' },
    // { label: 'Customer', value: '16' },
    // { label: 'Partner', value: '17' }
  ];

  const sortOrderOptions = [
    { label: 'Ascending', value: 'ASC' },
    { label: 'Descending', value: 'DESC' }
  ];

  const sortByOptions = [
    { label: 'User ID', value: 'id' },
    { label: 'User Name', value: 'name' },
    { label: 'User email', value: 'email' },
    { label: 'User Phone Number', value: 'phoneNumber' },
    { label: 'Registration Status', value: 'registrationStatus' },
    { label: 'Date Created', value: 'dateCreated' },
    { label: 'Package Rank', value: 'packageRank' }
  ];

  const sortingInputs = [
    { param: 'sortBy', type: INPUT_TYPE_SELECT, options: sortByOptions },
    { param: 'sortOrder', type: INPUT_TYPE_SELECT, options: sortOrderOptions }
  ];

  const filterInputs = [
    { param: 'id', type: INPUT_TYPE_SEARCH, placeholder: 'Search User ID' },
    {
      param: 'username',
      type: INPUT_TYPE_SEARCH,
      placeholder: 'Search Username'
    },
    {
      param: 'name',
      type: INPUT_TYPE_SEARCH,
      placeholder: 'Search First name'
    },
    {
      param: 'surname',
      type: INPUT_TYPE_SEARCH,
      placeholder: 'Search Last name'
    },
    {
      param: 'email',
      type: INPUT_TYPE_SEARCH,
      placeholder: 'Search Email'
    },
    {
      param: 'referrerId',
      type: INPUT_TYPE_SEARCH,
      placeholder: 'Search Referrer ID'
    },

    {
      param: 'packageRankType',
      type: INPUT_TYPE_SELECT,
      options: packageRankTypeOptions,
      placeholder: 'Rank'
    },
    {
      param: 'countryCode',
      type: INPUT_TYPE_SELECT,
      options: countries,
      placeholder: 'Country'
    },
    {
      param: 'sumsubStatus',
      type: INPUT_TYPE_SELECT,
      options: kycVerificationStatusOptions,
      placeholder: 'SumSub Verification Status'
    },
    {
      param: 'structureSide',
      type: INPUT_TYPE_SELECT,
      options: structureSideOptions,
      placeholder: 'Structure Side'
    },
    { param: '', type: INPUT_TYPE_DATE_RANGE }
  ];

  return (
    <>
      <RenderSorting
        sortingInputs={sortingInputs}
        searchParams={params}
        setSearchParams={setParams}
      />
      <RenderFilters
        filterInputs={filterInputs}
        searchParams={params}
        setSearchParams={setParams}
        initialParams={initialParams}
      />
    </>
  );
};
